import * as React from "react";
import { type IColumn } from "@fluentui/react";
import { makeObservable, computed } from "mobx";
import { observer } from "mobx-react";
import { type UUID } from "../../utils/uuid";
import { type User } from "../../api";

export interface ListUserProductivityItemCellProps {
    readonly userId: UUID;
    readonly column: IColumn;
}

import { store } from "../../store";

@observer
export class ListUserProductivityItemCell extends React.Component<ListUserProductivityItemCellProps> {
    constructor(props: ListUserProductivityItemCellProps) {
        super(props);
        makeObservable(this);
    }

    @computed private get user(): User | undefined {
        return store.repositoryUsers.byId(this.props.userId);
    }

    @computed private get departmentLabel(): string | undefined {
        if (!this.user || !this.user.departmentId) {
            return;
        }
        return store.repositoryDepartments.byId(this.user.departmentId)?.label;
    }

    @computed private get userShift(): string | undefined {
        if (!this.user || !this.user.shiftId) {
            return;
        }
        return store.repositoryShifts.byId(this.user.shiftId)?.label;
    }

    public render(): JSX.Element {
        const { column } = this.props;
        if (!this.user) {
            return <></>;
        }
        switch (column.key) {
            case "firstName":
                return <span>{this.user.firstName}</span>;
            case "lastName":
                return <span>{this.user.lastName}</span>;
            case "department":
                return <span>{this.departmentLabel}</span>;
            case "employeeId":
                return <span>{this.user.employeeId}</span>;
            case "shift":
                return <span>{this.userShift}</span>;
            case "loginHours":
                return <span>{store.i18n.formatDuration(this.user.totalLoginSeconds)}</span>;
            case "drivingHours":
                return <span>{store.i18n.formatDuration(this.user.totalDriveSeconds)}</span>;
            case "productivityKpi":
                if (!this.user.totalLoginSeconds) {
                    return <></>;
                }
                return (
                    <span>
                        {Math.trunc(
                            Math.round(
                                (this.user.totalDriveSeconds / this.user.totalLoginSeconds) * 100,
                            ),
                        )}
                        %
                    </span>
                );
            default:
                return <></>;
        }
    }
}
